var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        {
          on: {
            click: function ($event) {
              return _vm.openPopupPayed()
            },
          },
        },
        [
          _vm.cellValue
            ? _c("vs-button", { attrs: { size: "small", color: "success" } }, [
                _vm._v("Pagado"),
              ])
            : _c("vs-button", { attrs: { size: "small", color: "warning" } }, [
                _vm._v("No pagado"),
              ]),
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          attrs: { title: _vm.title, active: _vm.popupActive },
          on: {
            "update:active": function ($event) {
              _vm.popupActive = $event
            },
          },
        },
        [
          _c("p", [
            _vm._v(" Marcar como\n        "),
            _vm.cellValue
              ? _c("span", { staticClass: "text-dark uppercase" }, [
                  _vm._v("no pagado"),
                ])
              : _c("span", { staticClass: "text-dark uppercase" }, [
                  _vm._v("pagado"),
                ]),
          ]),
          _c(
            "vs-button",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "change_panel_payed_content_display",
                  expression: "'change_panel_payed_content_display'",
                },
              ],
              staticClass: "float-right",
              attrs: { color: "primary", type: "filled" },
              on: {
                click: function ($event) {
                  return _vm.changeStatePayed()
                },
              },
            },
            [_vm._v("Cambiar")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }